import { ConceptIds } from './Brands';

export class RewardWallet {
    name: string;
    walletCode: number;
    expirationDate: Date;
    id: number;
    description: string;
    details: string;
    backBody: string;
    rewardValue: number;
    concepts: Array<ConceptIds>;
    validAt?: Array<string>;
}
